import { permissionsRol as personalizeRol } from 'app/policies/roles/personalizeRol.access';
import { PATH_PERSONALIZE } from 'app/router/routesConfigPersonalize';

export function personalize(path, user) {
  if (PATH_PERSONALIZE === path) {
    return personalizeRol(user).sectionPersonalize;
  }

  return true;
}
